import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Subscription } from 'rxjs';
import { SnackBarService } from 'src/app/api/services/snack-bar.service';
import { EditProductRequest, LogsComparacao, JsonData } from 'src/app/api/models/product-comparator';
import { ProductComparatorService } from 'src/app/api/services';

@Component({
    selector: 'app-comparator-modal',
    templateUrl: './comparator-modal.component.html',
    styleUrls: ['./comparator-modal.component.css'],
    standalone: false
})
export class ComparatorModalComponent {
  request: EditProductRequest = {
    IdProdutoBio2: '',
    IdConcorrente: 0,
    NomePesquisa: '',
    PesquisarNovamente: true,
    MostrarDados: true,
  }
  loading: boolean = true;
  subscription: Subscription = new Subscription();
  productLogs!: any;
  productLogsDisplay: LogsComparacao[] = [];
  showDataOption!: boolean;
  searchAgainOption!: boolean;
  searchedName!: string;
  
  constructor(
    private productComparatorService: ProductComparatorService,
    private snackBarService: SnackBarService,
    public dialogRef: MatDialogRef<ComparatorModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { 
      productName: string, 
      productId: string, 
      competitorId: string,
      searchedName: string,
      showData: boolean,
      searchAgain: boolean,
      competitorName: string
    }
  ) {}

  ngOnInit() {
    this.searchedName = this.data.searchedName;
    this.showDataOption = this.data.showData;
    this.searchAgainOption = this.data.searchAgain;
    this.loadProductLogs();
  }

  loadProductLogs() {
    this.loading = true;
    console.log(this.data.productId);
    this.subscription.add(
      this.productComparatorService.getProductLogs(this.data.productId)
        .subscribe({
          next: (response) => {

            // parsing old data and new data to json
            this.productLogsDisplay = response.map(log => {
              let parsedOldData: JsonData | null = null;
              let parsedNewData: JsonData | null = null;
    
              try {
                parsedOldData = typeof log.oldData === 'string' ? JSON.parse(log.oldData) : log.oldData;
              } catch (e) {
                console.error('Error parsing oldData:', e);
              }
    
              try {
                parsedNewData = typeof log.newData === 'string' ? JSON.parse(log.newData) : log.newData;
              } catch (e) {
                console.error('Error parsing newData:', e);
              }
    
              return {
                ...log,
                oldData: parsedOldData,
                newData: parsedNewData
              } as LogsComparacao;
            });
            this.loading = false;
          },
          error: (error) => {
            console.error('Error fetching product logs:', error);
            this.loading = false;
          }
        })
    );
  }

  saveChanges(){
    this.loading = true;
    this.request.IdProdutoBio2 = this.data.productId;
    this.request.IdConcorrente = Number(this.data.competitorId);
    this.request.NomePesquisa = this.searchedName;
    this.request.PesquisarNovamente = this.searchAgainOption;
    this.request.MostrarDados = this.showDataOption;
    console.log(this.request);
    this.productComparatorService.updateProduct(this.request)
    .subscribe({
      next: () =>{
        console.log('Produto atualizado com sucesso!');
        this.snackBarService.openSnackBar(
          `Dados atualizados com sucesso!`,
          '#0AA174',
          '../../../../assets/Icons/correct.png'
        );
        this.loading = false;
      },
      error: (error) => {
        console.error('Error updating product:', error);
        this.snackBarService.openSnackBar(
          `Falha ao atualizar os dados!`,
          '#F97066',
          '../../../../assets/Icons/ErrorIcon.png'
        );
        this.loading = false;
      }
    }); 
  }

  closeModal(): void {
    this.dialogRef.close();
  }
}
